import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../store';
import { isTokenExpired } from './tokenUtils';
import { getSessionToken } from './cookies';
import { jsonParse } from './common';

const PrivateRoute = () => {
  const { token } = useAppSelector((state) => state.auth);
  
  const sessionAuth = jsonParse(getSessionToken('auth') || '{}');
  const validToken = token && sessionAuth.token ? token : null;
  
  const isAuthenticated = validToken && !isTokenExpired(validToken);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return <Outlet />;
};

export default PrivateRoute;
